import { useEffect } from 'react';
import { useListPresentationContextData } from '../context/ListPresentationContext';
import { useWidgetDndContextData } from 'src/context/WidgetDndContext';

export function useSetScrollSections() {
  const data = useListPresentationContextData();
  const {
    isMobile,
    contentTypeConditions,
    iterableList,
    isLayoutCarousel,
    listPresentationConfig,
  } = data.state;
  const { itemContainerRef } = data.refs;
  const { getConfigsAndUtils } = data.utilities;
  const { slideOffsetMultiplier, containerTracks } = getConfigsAndUtils().generalValues;
  const { setCarouselIndicatorConfigs } = getConfigsAndUtils().setters;

  const {
    widgetContextState: { previewDevice },
  } = useWidgetDndContextData();

  useEffect(() => {
    if (itemContainerRef && iterableList?.length) {
      setTimeout(() => {
        const { clientWidth, scrollWidth } = itemContainerRef || {};

        const sectionScrollWidth = Math.ceil(
          contentTypeConditions.testimonials
            ? scrollWidth / clientWidth
            : (iterableList?.length - containerTracks.numColumns) /
                slideOffsetMultiplier.forWidth +
                (!isMobile ? 1 : 0)
        );

        if (scrollWidth > clientWidth) {
          setCarouselIndicatorConfigs((data) => ({
            ...data,
            overflowSectionCount: sectionScrollWidth,
            // overflowSectionCount: Math.ceil(scrollWidth / clientWidth),
            currentFocusedSectionItem: 1,
          }));
        }
      }, 100);
    }
  }, [
    iterableList,
    isLayoutCarousel,
    isMobile,
    listPresentationConfig?.progressIndicator,
    previewDevice,
    containerTracks.numColumns,
    slideOffsetMultiplier.forWidth,
    itemContainerRef,
    contentTypeConditions.testimonials,
  ]);

  return null;
}
